import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Section from "../components/section"
import Heading from "../components/heading"

const PrivacyPolicy = ({ data }) => {
  const privacyPolicy = data?.allPrismicPrivacyPolicy?.nodes[0]?.data
  const footerData = data?.allPrismicFooter?.nodes[0]?.dataRaw

  return (
    <Layout footerData={footerData} noHero>
      <Seo title={privacyPolicy?.privacy_policy_header?.text} />
      <Section id="privacy-policy">
        <Heading className="text-primary text-center mt-5">
          {privacyPolicy?.privacy_policy_header?.text}
        </Heading>
        <div
          className="text-left mt-1"
          dangerouslySetInnerHTML={{
            __html: privacyPolicy?.privacy_policy_content?.html,
          }}
        />
      </Section>
    </Layout>
  )
}

export default PrivacyPolicy

export const data = graphql`
  query {
    allPrismicPrivacyPolicy {
      nodes {
        data {
          privacy_policy_content {
            html
          }
          privacy_policy_header {
            text
          }
        }
      }
    }

    allPrismicFooter {
      nodes {
        dataRaw
      }
    }
  }
`
